/*
 *  Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 *  Author Rihard Tsybulka <rykhard.tsybulka@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { Notification } from '../../utils/utils';
import { ProductItemAiCategories, DocumentResource } from '../api/documents/documentsClient.typings';
import { Cashback, VatVerificationInfo } from '../api/cashback/cashbackClient.typings';

export enum DocumentDetailsActionType {
    OPEN_REGISTRY_DOCUMENT_CARD_PAGE = 'RegistryDocumentCard/ open page',
    EXIT_REGISTRY_DOCUMENT_CARD_PAGE = 'RegistryDocumentCard/ exit page',

    FETCH_DOCUMENT_CARD_DETAILS_SUCCESS = 'RegistryDocumentCard/ fetch document card details success',
    FETCH_DOCUMENT_CARD_DETAILS_ERROR = 'RegistryDocumentCard/ fetch document card details error',

    FETCH_DOCUMENT_ITEMS_AI_CATEGORIES_START = 'RegistryDocumentCard/ fetch document items ai categories start',
    FETCH_DOCUMENT_ITEMS_AI_CATEGORIES_SUCCESS = 'RegistryDocumentCard/ fetch document items ai categories success',
    FETCH_DOCUMENT_ITEMS_AI_CATEGORIES_ERROR = 'RegistryDocumentCard/ fetch document items ai categories error',

    FETCH_CASHBACK_INFO_START = 'RegistryDocumentCard/ fetch cashback info start',
    FETCH_CASHBACK_INFO_SUCCESS = 'RegistryDocumentCard/ fetch cashback info success',
    FETCH_CASHBACK_INFO_ERROR = 'RegistryDocumentCard/ fetch cashback info error',

    FETCH_VAT_VERIFICATION_INFO_START = 'RegistryDocumentCard/ fetch vat verification info start',
    FETCH_VAT_VERIFICATION_INFO_SUCCESS = 'RegistryDocumentCard/ fetch vat verification info success',
    FETCH_VAT_VERIFICATION_INFO_ERROR = 'RegistryDocumentCard/ fetch vat verification info error',
}

export const openRegistryDocumentCardAction = (documentId: string) =>
    createAction(DocumentDetailsActionType.OPEN_REGISTRY_DOCUMENT_CARD_PAGE, documentId);

export const exitRegistryDocumentCardAction = () =>
    createAction(DocumentDetailsActionType.EXIT_REGISTRY_DOCUMENT_CARD_PAGE);

export const fetchDocumentCardDetailsSuccessAction = (payload: DocumentResource) =>
    createAction(DocumentDetailsActionType.FETCH_DOCUMENT_CARD_DETAILS_SUCCESS, payload);

export const fetchDocumentCardDetailsErrorAction = (notification: Notification) =>
    createAction(DocumentDetailsActionType.FETCH_DOCUMENT_CARD_DETAILS_ERROR, { notification });

export const fetchDocumentItemsAiCategoriesAction = (documentId: string) =>
    createAction(DocumentDetailsActionType.FETCH_DOCUMENT_ITEMS_AI_CATEGORIES_START, documentId);

export const fetchDocumentItemsAiCategoriesSuccessAction = (payload: ProductItemAiCategories[]) =>
    createAction(DocumentDetailsActionType.FETCH_DOCUMENT_ITEMS_AI_CATEGORIES_SUCCESS, payload);

export const fetchDocumentItemsAiCategoriesErrorAction = (notification: Notification) =>
    createAction(DocumentDetailsActionType.FETCH_DOCUMENT_ITEMS_AI_CATEGORIES_ERROR, { notification });

export const fetchCashbackInfoStartAction = () => createAction(DocumentDetailsActionType.FETCH_CASHBACK_INFO_START);

export const fetchCashbackInfoSuccessAction = (cashback: Cashback) =>
    createAction(DocumentDetailsActionType.FETCH_CASHBACK_INFO_SUCCESS, cashback);

export const fetchCashbackInfoErrorAction = () => createAction(DocumentDetailsActionType.FETCH_CASHBACK_INFO_ERROR);

export const fetchVatVerificationInfoStartAction = () =>
    createAction(DocumentDetailsActionType.FETCH_VAT_VERIFICATION_INFO_START);

export const fetchVatVerificationInfoSuccessAction = (verificationInfo: VatVerificationInfo) =>
    createAction(DocumentDetailsActionType.FETCH_VAT_VERIFICATION_INFO_SUCCESS, verificationInfo);

export const fetchVatVerificationInfoErrorAction = () =>
    createAction(DocumentDetailsActionType.FETCH_VAT_VERIFICATION_INFO_ERROR);

export type DocumentDetailsAction =
    | ReturnType<typeof openRegistryDocumentCardAction>
    | ReturnType<typeof exitRegistryDocumentCardAction>
    | ReturnType<typeof fetchDocumentCardDetailsSuccessAction>
    | ReturnType<typeof fetchDocumentCardDetailsErrorAction>
    | ReturnType<typeof fetchDocumentItemsAiCategoriesAction>
    | ReturnType<typeof fetchDocumentItemsAiCategoriesSuccessAction>
    | ReturnType<typeof fetchDocumentItemsAiCategoriesErrorAction>
    | ReturnType<typeof fetchCashbackInfoStartAction>
    | ReturnType<typeof fetchCashbackInfoSuccessAction>
    | ReturnType<typeof fetchCashbackInfoErrorAction>
    | ReturnType<typeof fetchVatVerificationInfoStartAction>
    | ReturnType<typeof fetchVatVerificationInfoSuccessAction>
    | ReturnType<typeof fetchVatVerificationInfoErrorAction>;
